module.exports = __webpack_public_path__ + "img/图片7.27ff88fd.jpg";